/* eslint-disable react/prop-types */
import React from 'react';
import { Table } from 'htlib-copy';

import customTypes from 'types';
import { useGetSingleMissionStats } from 'hooks/missions';

import SimpleCell from 'components/SimpleCell';
import AsyncUI from 'components/AsyncUI';

import './Stats.scss';

export default function Stats({ currentEntity }) {
  const getSingleMissionStatsQuery = useGetSingleMissionStats(
    { entityId: currentEntity.id },
    { enabled: Boolean(currentEntity.id) },
  );

  const stats = getSingleMissionStatsQuery.data ? getSingleMissionStatsQuery.data.stats : {};
  const { no = 0, checked = 0, unknown = 0, yes = 0, untagged = 0 } = stats;

  const totalEntityTags = no + unknown + yes + untagged;
  const checkedRatio = 100 * (checked / totalEntityTags || 0);
  const moderatedPercentage = checkedRatio.toFixed(2);

  const columns = [
    { head: 'Entity', dataKey: 'entity' },
    { head: 'Yes', component: () => <SimpleCell value={yes} /> },
    { head: 'No', component: () => <SimpleCell value={no} /> },
    { head: 'Unknown', component: () => <SimpleCell value={unknown} /> },
    { head: 'Not tagged', component: () => <SimpleCell value={untagged} /> },
    { head: 'Moderated', component: () => <SimpleCell value={checked} /> },
    { head: '% moderated', dataKey: 'moderatedPercentage' },
  ];

  const data = [
    {
      ...stats,
      moderatedPercentage,
      entity: currentEntity.displayName,
    },
  ];

  return (
    <div className="Stats">
      <AsyncUI query={getSingleMissionStatsQuery}>
        <h3 className="sectionTitle">Stats</h3>
        <div className="Stats_Table">
          <Table data={data} columns={columns} />
        </div>
      </AsyncUI>
    </div>
  );
}

Stats.propTypes = {
  currentEntity: customTypes.misc.missionEntity,
};

Stats.defaultProps = {
  currentEntity: {},
};
